import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'latLong'
})
export class LatLongPipe implements PipeTransform {
    public transform(value: number | string): string {
        if(typeof value === 'number'){
            return value.toFixed(3);
        }
        const parts: string[] =  (value as string).split('.');
        return `${parts[0]}.${parts[1].substring(0,3)}`;
    }
}
